import { twMerge } from "tailwind-merge";
import { motion } from "motion/react";

export type Props = {
  /** Content to animate */
  children: React.ReactNode;
  /** Additional CSS classes */
  className?: string;
  /** Enable layout animations */
  layout?: boolean;
};

/**
 * A fade animation wrapper using motion/react.
 */
export function MotionFade({ children, className, layout, ...props }: Props) {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.2 }}
      className={twMerge("", className)}
      layout={layout}
      data-testid="motion-fade"
      {...props}
    >
      {children}
    </motion.div>
  );
}

export default MotionFade;

